// It is safe to use this package here, because it is available in the new
// consumer app, and in the old package a mock is used.
// eslint-disable-next-line import/no-unresolved
import { notFound } from 'next/navigation';
import isNewConsumerApp from 'commons/isNewConsumerApp';

const notFoundNewConsumerApp = isNewConsumerApp ? notFound : () => {};

export default notFoundNewConsumerApp;
